export const ENV = {
  apiBaseUrl: 'https://dev-sas-caps.api.columbia.edu/api/v1/',
  oauthHost: 'https://oauth.cc.columbia.edu',
  casHost: 'https://cas.cc.columbia.edu',
  showApprovalButtonsRegardlessOfStatus: false,
  showApprovalButtonsRegardlessOfRole: false,
  /**
   * Temporary testing bypasses, by email.
   *
   * `bypassAttachmentGatesUsers` hides the evidence and letter prerequisites —
   * medical evidence, representational evidence, the Academic Appointments
   * revised letter, the Vice Provost signed letter — so a request can be walked
   * through the workflow without real documents.
   *
   * `bypassReviewRolesUsers` shows every review stage regardless of the roles
   * the user holds, so one account can act at all of them. Unlike
   * showApprovalButtonsRegardlessOfRole above, which is a blunt global switch,
   * these name individuals.
   *
   * These lists only decide what the UI OFFERS. The backend enforces the same
   * two rules from its own LEAVE_BYPASS_ATTACHMENT_GATES_USERS and
   * LEAVE_BYPASS_REVIEW_ROLES_USERS, so a stale UI build grants nothing and
   * access is revoked by clearing a Lambda variable rather than redeploying.
   *
   * Deliberate holes in the authorisation model, and wider together than either
   * alone: someone in both lists can drive any request to approved with no
   * evidence, no letter and no signature. Empty these before a real user
   * population arrives.
   */
  bypassAttachmentGatesUsers: [
    'js5470@columbia.edu',
    'ls3267@columbia.edu',
    'jp4812@columbia.edu',
    'sl4965@columbia.edu',
    'cl4634@columbia.edu',
    'sa3846@columbia.edu',
    'zs2152@columbia.edu',
    'am4150@columbia.edu',
    'rm271@columbia.edu',
  ] as readonly string[],
  bypassReviewRolesUsers: [
  ] as readonly string[],
  /**
   * Show the backend's own error text when an action fails, rather than a
   * generic message. On in every environment while CAPS is pre-production:
   * a tester or developer retrying blindly costs far more than an
   * unpolished sentence. Turn off before a real user population arrives.
   */
  showApiErrorDetails: true,
  /**
   * Hide the service record section for tenured academic officers in CUIMC
   * reporting units (codes 14-18). Their records are maintained outside
   * CAPS, so what we hold is incomplete and misleading. Leave history is
   * unaffected and stays visible.
   */
  hideCuimcTenuredServiceRecord: true,
  /**
   * Temporary: who may draft and submit a leave request for themselves while
   * viewing as an Academic Officer.
   *
   * Impersonation is read-only, which leaves an Academic Appointments admin
   * viewing as an officer unable to do the one thing that role exists for. This
   * lists the people that carve-out is for, by email.
   *
   * This list only decides whether the controls are OFFERED. Authorisation is
   * the backend's, via IMPERSONATION_SELF_SUBMIT_USERS — kept separately so a
   * stale UI build cannot grant anything, and so revoking access is one Lambda
   * environment variable rather than a redeploy. If the two drift, the worst
   * case is a visible button that returns a clear refusal.
   */
  impersonationSelfSubmitUsers: [
    'js5470@columbia.edu',
    'ls3267@columbia.edu',
    'jp4812@columbia.edu',
    'sl4965@columbia.edu',
    'cl4634@columbia.edu',
    'sa3846@columbia.edu',
    'zs2152@columbia.edu',
    'am4150@columbia.edu',
    'rm271@columbia.edu',
  ] as readonly string[],
};
